import ConnectedStore from './ConnectedStore';

export default ConnectedStore;
